import React, { FC } from 'react';
import { ArticlePreview } from '../../../../../shared/types';
import { Image } from '../../../shared/Image';
import Labels from '../../../shared/Labels';
import { calculateArticleLink } from '../../../shared/helpers';

import './index.scss';

const responsiveImageData = {
  sizes: ['(min-width: 480px) 555px', '432px'],
  srcSet: [400, 800],
};

interface ArticleListProps {
  articles: ArticlePreview[];
}

const ArticleList: FC<ArticleListProps> = ({ articles }) => (
  <div className="articles">
    {articles.map((article, idx) => (
      <div key={idx}>
        <a href={calculateArticleLink(article)} className="media-wrapper">
          <Image
            responsiveImageData={responsiveImageData}
            srcset={[article.mainImage.image]}
            alt={article.mainImage.alt}
            lazyLoad={idx > 5}
          />
        </a>
        <a href={calculateArticleLink(article)} className="title">
          <h3>{article.title}</h3>
        </a>
        <Labels publishedDate={article.publishedDate} timeToRead={article.timeToRead} />
      </div>
    ))}
  </div>
);

export default ArticleList;
